import script from "./UnpricedSizesMarker.vue?vue&type=script&setup=true&lang=js"
export * from "./UnpricedSizesMarker.vue?vue&type=script&setup=true&lang=js"

import "./UnpricedSizesMarker.vue?vue&type=style&index=0&id=409e15b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409e15b4"]])

export default __exports__